import { ENVIRONMENT_ROOT_VOLUME_GIB } from "@/lib/api";

/** 選んだ容量の 1 時間分のクレジット。稼働中・停止中で同じ。 */
export function rootVolumeCreditsPerHour(gib: number, creditsPerGibHour: number): number {
	return gib * creditsPerGibHour;
}

/**
 * 入力文字列をルートボリューム容量 (GiB) として解釈する。整数でなければ null、範囲外なら
 * 理由つきのエラーを返す (フォームのインライン表示用)。
 */
export function parseRootVolumeGib(
	input: string,
): { gib: number; error: null } | { gib: null; error: string } {
	const { min, max } = ENVIRONMENT_ROOT_VOLUME_GIB;
	const trimmed = input.trim();
	if (!/^\d+$/.test(trimmed)) {
		return { gib: null, error: "容量は整数 (GiB) で指定してください。" };
	}
	const gib = Number(trimmed);
	if (gib < min || gib > max) {
		return { gib: null, error: `容量は ${min} 〜 ${max} GiB で指定してください。` };
	}
	return { gib, error: null };
}

/**
 * 入力文字列を拡張後の容量 (GiB) として解釈する。整数でなければ null、現在以下 (縮小不可) や
 * 上限超えなら理由つきのエラーを返す。
 */
export function parseExpandedRootVolumeGib(
	input: string,
	currentGib: number,
): { gib: number; error: null } | { gib: null; error: string } {
	const trimmed = input.trim();
	if (!/^\d+$/.test(trimmed)) {
		return { gib: null, error: "容量は整数 (GiB) で指定してください。" };
	}
	const gib = Number(trimmed);
	if (gib <= currentGib) {
		return {
			gib: null,
			error: `縮小はできません。現在の ${currentGib} GiB より大きい値を指定してください。`,
		};
	}
	if (gib > ENVIRONMENT_ROOT_VOLUME_GIB.max) {
		return {
			gib: null,
			error: `容量は ${ENVIRONMENT_ROOT_VOLUME_GIB.max} GiB 以下で指定してください。`,
		};
	}
	return { gib, error: null };
}
